import React from "react";
import style from "./Cocina.module.css";
import { SliderEspacios } from "./SlidersEspacios/SlidersEspacios";

export const Espacios = () => {
  return (
    <div className={style.container} id="espacios">
      <div className={style.background}>
        <div className={style.b1}> </div>
        <div className={style.b2}> </div>
        <div className={style.b3}> </div>
      </div>

      <div className={style.item1}>
        <SliderEspacios></SliderEspacios>
      </div>
    </div>
  );
};
